export class BackupZeroEtlColumnExtract {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "schema",
            "baseName": "schema",
            "type": "string",
            "format": ""
        },
        {
            "name": "preserveRawColumn",
            "baseName": "preserveRawColumn",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "asKeyValueEntries",
            "baseName": "asKeyValueEntries",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "extendedJson",
            "baseName": "extendedJson",
            "type": "BackupZeroEtlExtendedJsonMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlColumnExtract.attributeTypeMap;
    }
    constructor() {
    }
}
